// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1":"29624fabf2ac47e5","175":"300609ab8dc0634a","603":"48ba93f25ed1acde","850":"9094ce8c75d867bf","945":"4afb6a503d374d0c"}[chunkId] + ".js";
};